import * as z from "zod";

export const updateCheckoutDeliveryEstimatesEnabled = {
  name: "updateCheckoutDeliveryEstimatesEnabled" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.null(),
};
